// extracted by mini-css-extract-plugin
export default {"resources-page-content":"style_resources-page-content__cltKp","grid":"style_grid__clz97"};